import { IRequestWrap } from '../../../server/IServer';
import { ISunnyRequestBuilderConstructor, SunnyRequestBuilder } from '../SunnyRequestBuilder';

/**
 * 한 종류의 `RequestBuilder`만 사용하는 액션.
 */
export class BaseActions<T extends SunnyRequestBuilder> {
  protected readonly requestBuilder: T;

  constructor(reqBuilderCtor: ISunnyRequestBuilderConstructor<T>, req?: IRequestWrap) {
    if (req) {
      this.requestBuilder = reqBuilderCtor.fromReq(req);
    } else {
      this.requestBuilder = new reqBuilderCtor();
    }
  }
}
